module.exports = __webpack_public_path__ + "static/charis_profile-8bc5b8049db07e8a7647483f8afd4eb7.jpeg";